<template>
  <div>
    <header class="dashboard-header">
      <div class="container-cls">
        <v-row justify="center">
          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="2"
            lg="2"
            xl="2"
            class="grow-logo"
          >
            <router-link :to="{ path: '/' }" class="dashboard-logo ">
              <img
                src="https://growbiotech-prod.s3.amazonaws.com/1606973000233.png"
                alt
              />
            </router-link>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10" class="pb-0">
            <h2 class="page-header ma-0">
              <strong>Privacy Policy</strong>
            </h2>
          </v-col>
        </v-row>
      </div>
    </header>
    <v-list :class="$vuetify.breakpoint.xsOnly ? 'pa-3 pt-0' : 'pa-15 pt-0'">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >Our company is Grow Group Plc; company number
            "11056972".</v-list-item-title
          >
          <v-list-item-title class="title-text">Your Privacy</v-list-item-title>
          <v-list-item-subtitle class="subtitle-text"
            >At Grow Group Plc, your privacy is important to us. This privacy
            statement explains what Personal Information Grow Group Plc ("Grow
            Group Plc", "we", "us", "our", “App”, “Services”) collects from you
            through our products and how we use that
            information.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc serves a number of groups of users in different
            ways. References to products in this statement include Grow Group
            Plc services, which are offered through our websites and
            app.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Please read product-specific details in this privacy statement,
            which provide additional information about some Grow Group Plc
            products.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >This policy applies to any users of the Services of Grow Group Plc
            or its affiliates anywhere in the world, and to anyone else who
            contacts or otherwise submits information to Grow Group Plc, unless
            noted below.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >1. Data Protection Principles</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We are committed to complying with data protection law and
            principles, which means that your Personal Information will
            be:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. Processed lawfully, fairly and in a transparent
            way;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. Collected for specific, explicit and legitimate purposes stated
            in this policy and not used in any way that is incompatible with
            those purposes;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >3. Adequate, relevant and limited to what is necessary for those
            purposes;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >4. Accurate and, where necessary, kept up to
            date;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >5. Kept for no longer than is necessary for those purposes;
            and</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >6. Processed securely.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Accountability is one of the GDPR principles. Grow Group Plc must
            put in place appropriate technical and organisational measures to
            meet these requirements and review and update where necessary the
            measures that have been put into place. Being accountable is key to
            maintain trust with other parties and may help mitigate any
            enforcement action if the situation arises.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >2. Collection of Personal Information</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc acts as the data controller for the information you
            provide or that is collected by Grow Group Plc or its affiliates.
            Grow Group Plc collects Personal Information to operate effectively
            as a business and to provide you, the user, with tailored services
            and products.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >You have choices about the Personal Information we collect. When
            you are asked to provide Personal Information, you may decline. But
            if you choose not to provide Personal Information that is necessary
            in order for us to provide services to you, you may not be able to
            use that product.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We provide further information, below, on the types of Personal
            Information we obtain and how we use them, throughout your use of
            our service and products.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >2.1 - Collection of Personal Information</v-list-item-title
          >
          <v-list-item-title class="title-text"
            >Information you give to us:</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We will collect and process the Personal Information from you that
            you give to us by filling in forms on our website or App or by
            corresponding with us by phone, email or otherwise. It includes
            information you provide when you register to use the site or App,
            subscribe to our service, search for a product, participate in
            discussion boards or other social media functions on or via the site
            or App, enter a competition, promotion or survey, submit a query,
            and when you report a problem with the site or App. All Personal
            Information is kept private and will not be shared without obtaining
            your prior consent.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >If you are asked to provide this express consent, we will clearly
            and unambiguously explain to you what Personal Information we will
            be sharing, with whom and for what purpose. Consent for sharing of
            Personal Information (see sections 3.4 and 3.5) will be asked for
            separately to this privacy policy.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >The (“Personal Information”) you give us may include the types
            described below (the purpose of data collection is written next to
            each):</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Your name; to create an account on the Grow Group Plc
            app</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Email address; to create an account on the Grow Group Plc
            app</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Phone number; to create an account on the Grow Group Plc
            app</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Date of birth; to ensure you receive appropriate personalised
            support from the Grow Group Plc app.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Demographic information; to ensure you receive appropriate
            personalised support from the Grow Group Plc
            app.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Password; to create an account on the Grow Group Plc app. We are
            not able to access user passwords.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >We may also collect sensitive personal information about your
            health. This is described in further detail below. The purpose of
            data collection is written next to each.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >General health information:</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Details of cancer diagnosis; to provide a tailored experience. For
            example, by recommending articles relevant to your cancer
            type.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Treatment course/cycle; to provide a tailored experience. For
            example, by providing tips on how to manage side effects of
            particular treatments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Healthcare provider name; to ensure that if your healthcare
            provider is a Grow Group Plc partner we can include specific
            articles or advice from them in our articles
            library.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Healthcare provider contact details; to help you manage all aspects
            of your care via the Grow Group Plc app.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >Details of your care:</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Medication you’re taking; to help you manage your medication
            schedule, provide medication reminders and log medication you’ve
            taken.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Medical appointments; to help you manage your appointment schedule,
            provide appointment reminders and help you prepare for
            them</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Severity of symptoms and side effects; to help you track your
            progress through treatment and prepare for
            appointments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Activity levels; to help you track your progress through treatment
            and prepare for appointments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Sleep; to help you track your progress through treatment and
            prepare for appointments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Nutrition; to help you track your progress through treatment and
            prepare for appointments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Hydration; to help you track your progress through treatment and
            prepare for appointments.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Notes; to help you track your progress through treatment and
            journal your overall experience
            electronically.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >Health related metrics:</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Heart rate (via wearable device integration or third party
            services); to help you track your progress through treatment as well
            as enabling the Vineheath app to deliver personalised
            recommendations to support you.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Blood pressure (via wearable device integration or third party
            services); to help you track your progress through treatment as well
            as enabling the Vineheath app to deliver personalised
            recommendations to support you.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Weight; to help you track your progress through treatment as well
            as enabling the Vineheath app to deliver personalised
            recommendations to support you.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Temperature; to help you track your progress through treatment as
            well as enabling the Vineheath app to deliver personalised
            recommendations to support you.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text">Other:</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Gender; Understanding gender allows healthcare professionals and
            our partners to better understand how life-saving cancer drugs
            affect different people and develop them to be more effective. It
            also allows the Grow Group Plc app to deliver a more personalised
            user experience.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Ethnicity; Understanding ethnicity allows healthcare professionals
            and our partners to better understand how life-saving cancer drugs
            affect different people and develop them to be more effective. It
            also allows the Grow Group Plc app to deliver a more personalised
            user experience.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >Any information about your health and ethnicity is classed as
            sensitive Personal Information and we ensure that additional
            safeguarding measures are in place to protect this information. Our
            lawful basis for processing this sensitive Personal Information is
            your consent. You can withdraw your consent at any time - for more
            information please email
            privacy@growgroupplc.com.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Part of this information is necessary to complete your user
            registration and for you to use our App and Services (for more
            information on what we use your data for, see section 3) If you
            decline to provide this information during the registration process
            you will not be able to create an account on the App and use our
            Services.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >Information we receive from other sources:</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >If you input an access code that you have received from a Patient,
            Caregiver, Charity or a Healthcare Provider when you download the
            Grow Group Plc app, we will be able to tell which third party has
            provided you with this code.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We will receive information from anyone that you give permission to
            enter information into the App on your behalf (such as a Caregiver
            or a Healthcare Provider) ("Permitted Third Party/Parties"). If you
            allow your Permitted Third Parties permission to edit your
            information, then they may give us information about your symptoms,
            medications and treatments. You can change your Permitted Third
            Parties under your settings in your account and change the
            permissions allocated to each Permitted Third
            Party.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >If you are a Permitted Third Party, we may receive information
            about you from the patient. This information is described in the
            table below:</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <!-- Groups -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >Personal information concerning permitted third
            parties:</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Your name; to create an account on the Grow Group Plc app and help
            set up app features that are relevant to their role (e.g. carer
            support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Phone number; to create an account on the Grow Group Plc app and
            help set up app features that are relevant to their role (e.g. carer
            support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Email address; to create an account on the Grow Group Plc app and
            help set up app features that are relevant to their role (e.g. carer
            support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Relationship to patient; to help set up app features that are
            relevant to their role (e.g. carer support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Job title; to help set up app features that are relevant to their
            role (e.g. carer support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon class="mr-0 pl-4">
          <v-icon>mdi-circle-medium</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-innner-icontext"
            >Location; to help set up app features that are relevant to their
            role (e.g. carer support)</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >If you decide to allow any third party wearable devices to connect
            with our Services, we will receive information about you such as
            your exercise, activity, heart rate, temperature, sleep, weight and
            blood pressure from these devices via
            Bluetooth.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >2.2 - Engagement data, Cookies and other data collection
            technologies</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >When you begin to use our App or services, we monitor engagement
            and feature usage on our platform by recording every interaction you
            have with products you are registered on. This includes, but is not
            limited to, page visits, content viewed and logs made on our
            platform.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We also infer your location based on your IP address during
            registration and for opt-ins. In addition to IP address, our
            platform automatically collects data about your device, including
            the model, platform, locale code and UUID (universally unique
            identifier) every time you visit the Grow Group Plc website or app.
            This information may also be collected in combination with an
            identifier associated with your device to enable us to recognise
            your mobile browser or device when you return to the site or the
            App.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc uses cookies and similar technologies on our online
            services to allow us to store your personal preferences and
            settings; optimise login processes; maintain a high level of
            security and to monitor and analyse performance of our online
            services. On our website, we may use traffic log cookies to track
            pages you view. The purpose of this is to analyse web page traffic
            in order to further optimise the journey users must undertake to
            access content that is relevant to them. You may adjust the settings
            on your browser to refuse cookies, however, this may lead to limited
            access to our online services.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >In addition to cookies, we may log information about your device,
            including the existence of cookies, your IP address and information
            about your browser. The purpose of this information collection is to
            diagnose service issues and to administer and track your usage of
            our platforms.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Information about your visit may include the full Uniform Resource
            Locators (URL), clickstream to, through and from the site, and any
            phone number used to call our customer service number or social
            media handle used to connect with our customer service
            team.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >2.3 - Third party aggregate data</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Our third parties may gather non-personal digital properties to
            enrich aggregate analytics, including Google
            Analytics.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >All of Grow Group Plc’s third-party service providers and other
            entities in the group are required to take appropriate security
            measures to protect Personal Information in line with our policies.
            Grow Group Plc only allows service providers to process Personal
            Information for specified purposes and in accordance with Grow Group
            Plc’s instructions.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3. How Grow Group Plc uses your Personal
            Information</v-list-item-title
          >
          <v-list-item-title class="title-text"
            >3.1 - To operate effectively as a business and to perform essential
            business operations, including developing and providing products
            optimised for patients and clinicians.</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We are motivated to provide products which offer outstanding
            resources for people living with long-term health conditions
            ("patients"), including content and resources tailored to a user’s
            specific need, stage of disease, medications, appointments,
            location, current condition and treatment (as detailed in section
            2). We will show you and/or a Permitted Third Party this
            information.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >To enhance your enjoyment and productivity on our platform, we
            endeavour to identify and recommend the most relevant features
            through personalised notifications, based on your profile,
            medications, symptom tracking, health condition(s) and recent
            activities. To ensure your experience with our products is seamless,
            we continuously re-examine and iteratively optimise user journeys on
            our platform.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc uses your Personal Information to identify you and
            notify you about changes to our service. We infer your location from
            your device IP address in order to geo-restrict certain content on
            our platform.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Product issues, identified by users and communicated through
            customer support, are effectively diagnosed and resolved using data
            collected from interactions on the platform. Decisions on product
            development and evaluations of product performance are based on
            aggregate analysis and business intelligence.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc may use your email address, phone number and/or
            details to present you with occasional marketing messages where you
            have opted in to receive these, based on our legitimate interest in
            marketing our services to you and subject to your right to opt out
            at any time. We also use third parties (such as LinkedIn, Google,
            Facebook, YouTube) to serve advertisements that may be of interest
            to you on other websites.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We use third party analytics providers including Google, Mixpanel,
            Branch and others, to collect information about the usage of our app
            and website to enable us to improve how they work and deliver you a
            better service.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >The information allows us to see the overall patterns of usage on
            the apps, helps us record any difficulties you have with them, shows
            us whether our advertising is effective or not, and allows us to use
            responses to advertisements to optimise ad
            performance.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >All our third-party service providers and other entities in the
            group are required to take appropriate security measures to protect
            your Personal Information in line with our policies. We only allow
            them to process your Personal Information for specified purposes and
            in accordance with our instructions.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >In addition to the specific disclosures of Personal Information set
            out in this section, we may disclose your Personal Information where
            such disclosure is necessary for compliance with a legal obligation
            to which we are subject, or in order to protect your vital interests
            or the vital interests of another natural person. We may also
            disclose your Personal Information where such disclosure is
            necessary for the establishment, exercise or defence of legal
            claims, whether in court proceedings or in an administrative or
            out-of-court procedure.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We will disclose your Personal Information to third parties in the
            event that we sell or buy any business or assets, in which case we
            will disclose your Personal Information to the prospective seller or
            buyer of such business or assets subject to the terms of this
            privacy policy.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We will disclose your Personal Information to third parties if Grow
            Group Plc Digital Limited or substantially all of its assets are
            acquired by a third party, in which case Personal Information held
            by it about its customers will be one of the transferred
            assets.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3.2 - To deliver communications of personal interest including
            product and content releases, motivational prompts and in response
            to product queries or support requests.</v-list-item-title
          >
          <v-list-item-title class="title-text"
            >Direct communications</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Communications sent by Grow Group Plc come in the form of emails to
            the email address provided by you during the registration process
            and through notifications delivered to your device. Grow Group Plc
            may send you communications relating to new and existing product and
            content releases and updates. We send such communications so that
            you are aware of changes we are making to the content or features of
            our products, or new releases, which could affect the usefulness of
            our core services to you.</v-list-item-subtitle
          >
          <v-list-item-title class="title-text"
            >Third party communications</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We may ask you during registration whether you want to receive
            third party communications such as promotional material related to
            other services outside of our platform. You, of course, have the
            right to opt out of such email communication at any time by using
            the unsubscribe link, found at the bottom of every email, or by
            updating your account setting in the app. Grow Group Plc will not
            send you communications unrelated to its core services, unless you
            specifically tell us you are interested in receiving
            them.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3.3 - Anonymised & aggregated information for commercial
            partners</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >The purpose of Grow Group Plc is to create a future in which people
            living with cancer are able to manage their care more effectively
            but also have access to better life-saving drugs; we want to further
            our partners’ knowledge of cancer and enable them to deliver better
            clinical care.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We can only achieve our purpose if we share anonymised and
            aggregated (non-personal) information about our users’ conditions
            with our strategic partners: oncologists, research institutions,
            pharmaceutical companies and other organisations in the medical
            sector. The information that we share with our strategic partners is
            fully anonymised and aggregated unless you are part of a Grow Group
            Plc Care Program (see section 3.4) or if you are part of a Clinical
            Trial or other projects with our partners. (see section 3.5). It
            cannot be used to identify you in any way.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >We may also share with our commercial partners aggregated
            information that does not personally identify you, but which shows
            general trends, for example, the number of users of our
            service.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3.4 - To track and report your Grow Group Plc data and insights
            with your doctor or care provider within a Grow Group Plc Care
            Program, with your prior knowledge and consent</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >By signing up our platform as a member of a Grow Group Plc Care
            Program (“VCP”) you agree to share your Grow Group Plc data and
            insights with your doctor or care provider; we will provide useful
            insights and notifications to improve your care whilst at home and
            in the care setting. Owners of a VCP include, but are not limited
            to, doctors, nurses, clinicians, academic institutions, and other
            care providers. Data and insights shared are limited to content on
            the platform that belongs to the Grow Group Plc Care Program. You
            have the right at any time to opt out of this sharing by sending a
            written request to privacy@growgroupplc.com.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >3.5 - To track and report your Grow Group Plc data and insights
            within a Grow Group Plc Clinical Trial Partnership, with your prior
            knowledge and consent</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >By signing up and agreeing to share your Grow Group Plc data and
            insights with a Grow Group Plc Clinical Trial Partner (“VCT”), we
            will provide useful insights and notifications to improve your care
            both at home and in the care setting whilst you are part of a
            clinical trial or other projects with our partners. Owners of a Grow
            Group Plc Clinical Trial Partnership include, but are not limited
            to: academic institutions, clinical research organisations and
            pharmaceutical companies. Data and insights shared are limited to
            content on the platform that belongs to the specific Clinical Trial
            Partner. You have the right at any time to opt out of this sharing
            by sending a written request to
            privacy@growgroupplc.com.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >4. Transparency and Choices</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >In this section, we have summarised the rights that you have under
            data protection law. The information we provide in this section is a
            brief summary of your rights under data protection law and you
            should still read the relevant laws and guidance from the regulatory
            authorities for a full explanation of these
            rights.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Your principal rights under data protection law
            are:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. the right to be informed;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. the right of access;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >3. the right to rectification;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >4. the right to erasure;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >5. the right to restrict processing;</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >6. the right to data portability</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >7. the right to object; and</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >8. rights in relation to automated decision making and
            profiling.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >You have the right to confirmation as to whether or not we hold or
            process your Personal Information and, where we do, access to the
            Personal Information, together with certain additional information.
            That additional information includes details of the purposes of the
            processing, the categories of Personal Information concerned and the
            recipients of the Personal Information. Providing the rights and
            freedoms of others are not affected, we will supply to you a copy of
            your Personal Information, or do one of the
            following:</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >1. We may ask you to verify your identity, or ask for more
            information about your request; or</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-inner-text"
            >2. Where we are legally permitted to do so, we may decline your
            request, but we will explain why if we do so.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle class="subtitle-text"
            >You have the right to have any inaccurate Personal Information
            about you rectified and, taking into account the purposes of the
            processing, to have any incomplete Personal Information about you
            completed.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >In some circumstances, you have the right to the erasure of your
            Personal Information without undue delay. Those circumstances
            include: the Personal Information are no longer necessary in
            relation to the purposes for which they were collected or otherwise
            processed; you withdraw consent to consent-based processing; you
            object to the processing under certain rules of applicable data
            protection law; the processing is for direct marketing purposes; and
            the Personal Information being unlawfully processed. However, there
            are exclusions of the right to erasure. The general exclusions
            include where processing is necessary, for example: for exercising
            the right of freedom of expression and information; for compliance
            with a legal obligation; or for the establishment, exercise or
            defence of legal claims.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >You have the right to request that your Personal Information is no
            longer processed for example, due to the inaccuracy of the Personal
            Information or the reason for the Personal Information being
            processed.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >If you have given additional consent for your Personal Information
            to be shared to a third party, including academic institutions,
            medical device companies and pharmaceutical companies, you have the
            right to withdraw this consent at any time. You have the right to
            request that your Personal Information be transferred to another
            party.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >If you consider that our processing of your Personal Information
            infringes data protection laws, you have a legal right to lodge a
            complaint with a supervisory authority responsible for data
            protection. You may do so in the EU member state of your habitual
            residence, your place of work or the place of the alleged
            infringement.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >To the extent that the legal basis for our processing of your
            Personal Information is consent, you have the right to withdraw that
            consent at any time. Withdrawal will not affect the lawfulness of
            processing before the withdrawal. If you opted in to third party
            marketing communications when you registered, you may opt-out at any
            time within the app, or by emailing
            privacy@growgroupplc.com.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >Lastly, you will not be subject to decisions that will have a
            significant impact on you based solely on automated
            decision-making.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >You may exercise any of your rights in relation to your Personal
            Information by written notice to us or by any of the methods
            specified in section.</v-list-item-subtitle
          >

          <v-list-item-subtitle class="subtitle-text"
            >To contact us in relation to any of these requests, please use the
            email address privacy@growgroupplc.com.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >5. How long we keep your information</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We will keep your Personal Information in our database for as long
            as you wish to remain on our database in order to receive the
            benefits of our services. You can edit or update your Personal
            Information at any time. We may also contact you periodically to
            prompt you to update your Personal Information. This prompt will
            give you an opportunity to notify us if you want us to remove you
            from our database. If you do not respond to these prompts we will
            take this to mean that you want to continue using Grow Group Plc. If
            you do respond to these prompts and wish to remove your personal
            information we will remove your personal information from our
            database within 1 month.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >Please note that if you have consented to a project of the type
            described in section 3 which has now concluded, we will only be able
            to delete the Personal Information stored in our databases. As
            described in section 3.3 Grow Group Plc may share anonymised and
            aggregated information with partners and therefore this cannot be
            removed. However, shared information is not Personal
            Information.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >6. Information Security and International
            Transfers</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >Grow Group Plc is committed to protecting the security of Personal
            Information by endeavouring to ensure appropriate technologies and
            processes are maintained to avoid unauthorised access or disclosure.
            We utilise, for all data storage and processing purposes, Amazon Web
            Services ("AWS"), Google’s G Suite and Google Cloud. Specifically,
            all our AWS storage containers and databases are located in London
            (UK) (with possible transit through US/EU storage containers). All
            Personal Information collected by the Grow Group Plc app is
            encrypted to the highest possible degree both when it is stored in
            our databases and when it is being
            transmitted.</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title-text"
            >7. Changes to this Privacy Policy and Further
            Information</v-list-item-title
          >
          <v-list-item-subtitle class="subtitle-text"
            >We may revise this Privacy Policy from time to time. The most
            current version of the policy will govern our use of your
            information and will always be here. If we make a change to this
            policy that, in our sole discretion, is material, we will notify you
            via an app notification or email to the email address associated
            with your account. By continuing to access or use our services after
            those changes become effective, you agree to be bound by the revised
            Privacy Policy.</v-list-item-subtitle
          >
          <v-list-item-subtitle class="subtitle-text"
            >If you would like further information about privacy at Grow Group
            Plc, please contact us at privacy@growgroupplc.com. In the UK,
            general information on protection of Personal Information, including
            your rights and freedoms under the General Data Protection
            Regulation, is available via the Information Commissioner’s Office
            (“ICO”). Their website address is
            <a
              class="website-url"
              target="_blank"
              href="http://www.ico.org.uk/"
            >
              www.ico.org.uk.</a
            ></v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <div class="bg-shape">
        <img
          src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299668242.png"
          alt
        />
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.title-text {
  font-size: 24px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 8px 0px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-text {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 12px 0px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-inner-text {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 12px 28px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.subtitle-innner-icontext {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 0px 8px;
  line-height: 1.4 !important;
  font-family: "Nunito Sans", sans-serif !important;
}
.bg-shape {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 0;
}
.bg-shape img {
  width: 100%;
  height: 100%;
  -o-object-position: center bottom;
  object-position: center bottom;
  -o-object-fit: cover;
  object-fit: cover;
}
.website-url {
  z-index: 1;
  position: absolute;
  padding-left: 6px;
}
.grow-logo {
  display: contents;
}
.page-header {
  text-align: center;
  color: #27445b;
}
</style>
